import { SettingsInjections } from 'generics/settingsInjections';

////////////////////////////////////////////
// class GamesCallDev
/*class GamesCallDev extends GenericAPICall {
  normalizeResponse( resp )  {
    return resp.result || resp.response;
  }


  getInterfaceUrl()  {
    //return "http://achievement.loc/config/games.json";
    return SettingsInjections.getUsedCircuit().trade_server;
  }
}*/

export function GamesList()  {
  // TODO: Load games from some server (not market)
  const games = SettingsInjections.getGamesList();
  return Promise.resolve({ games });

  /*const language = SettingsInjections.getUsedLocale().code;

  let callGlobalInfo = new GamesCallDev("cln_market_info");
  callGlobalInfo.setRetryPolicy( 5, 100, 500 );
  callGlobalInfo.append("language", language );

  return callGlobalInfo.POST().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`MarketGlobalInfo(${language}) - got response:`, resp);
    return resp;
  });*/
}